import 'css-chunksrc/feature/settings/SettingsLatencyTest.module.scss';export default {
  "root": "SettingsLatencyTest_root"
};